import React from "react";
import { GetUser } from "../../utils/AuthUtils";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

export function HomePage() {
  return (
    <>
      <div className="vivigas-container container-fluid">
        <div className="row wrap-login">
          <div className="col-md-5 d-none d-md-block">
            <div>
              <img
                className="logo"
                src={toAbsoluteUrl("/media/png/logo/logo-color.svg")}
                alt="Vivigas logo"
              ></img>
            </div>
          </div>

          <div className="col-sm-12 d-md-none text-center">
            <img
              className="logo-small"
              src={toAbsoluteUrl("/media/png/logo/logo-color.svg")}
              alt="Vivigas logo"
            ></img>
          </div>

          <div className="col-sm-12 col-md-7">
            <div className="text-left login-title">
              Benvenuto {GetUser().given_name + " " + GetUser().family_name}!
            </div>
          </div>
          <footer>
            <div className="container">
              <div className="row text-center">
                <span className="col-3 nav-item">
                  <a href="https://www.vivienergia.it/">VIVI energia</a>
                </span>
                <span className="col-3 nav-item">
                  <a href="https://www.vivienergia.it/normativa/informativa-privacy">
                    Privacy
                  </a>
                </span>
                <span className="col-3 nav-item">
                  <a href="https://www.vivienergia.it/contatti">Contatti</a>
                </span>
                <span className="col-3 nav-item">
                  <a
                    href="/CLUCIT22-00192-Manuale Utente-VIVIENERGIA-BlackList Tool.pdf"
                    download
                  >
                    Manual Utente
                  </a>
                </span>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
}
